import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Observable, of} from 'rxjs';
import {Action} from '@ngrx/store';

import * as sessionActions from './session.actions';
import {catchError, map, mergeMap} from 'rxjs/operators';
import {SessionService} from './session.service';
import {SessionModel} from './session.model';

@Injectable()
export class SessionEffects {

	constructor(private action$: Actions,
				private sessionService: SessionService) {
	}

	@Effect()
	getSession$: Observable<Action | void> = this.action$.pipe(
		ofType<sessionActions.DemandeSession>(sessionActions.sessionActionsType.DEMANDE_SESSION),
		map((action: sessionActions.DemandeSession) => action.payload),
		mergeMap(
			(id: number) =>
				this.sessionService.getOne(id).pipe(
					map(
						(session: SessionModel) => {
							return new sessionActions.DemandeSessionOk(session);
						}
					),
					catchError(err => {
						return of(new sessionActions.DemandeSessionKo(err));
					})
				)
		)
	);

}
